export default {
  1: "Arbeitsplatz",
  2: "Selbständigkeit",
  4: "Ausbildungsplatz",
  34: "Praktikum/Traineestelle",
  40: "Künstler"
};
